import './Navbar.css';
import Ticker from '../Ticker/Ticker';
import { FaSearch, FaBars, FaTimes } from "react-icons/fa";
import { FiUser } from "react-icons/fi";
import { HiOutlineShoppingBag } from "react-icons/hi";
import { Link } from "react-router-dom";
import { useState } from "react";

function Navbar({ cartCount }) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <Ticker />

      <div className="announcement-bar">
        Code WIN120 | Upto 40% OFF for orders above ₹1600 | Pay Online
      </div>

      <nav className="navbar">

        <div className="logo">
          GYMWEAR
        </div>

        <div
          className="mobile-menu-icon"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>

        <ul className={`nav-links ${menuOpen ? "active" : ""}`}>

          <li>
            <Link to="/" onClick={() => setMenuOpen(false)}>
              Home
            </Link>
          </li>

          <li className="dropdown">
            <span>Women ▾</span>

            <div className="dropdown-menu">
              <Link to="/women-tops">Womens Tops</Link>
              <Link to="/women-leggings">Womens Leggings</Link>
            </div>
          </li>

          <li className="dropdown">
            <span>Men ▾</span>

            <div className="dropdown-menu">
              <Link to="/summer-jackets">Summer Jacket / Hoodie</Link>
              <Link to="/mens-tees">Mens Tee</Link>
            </div>
          </li>

          <li>
            <Link to="/accessories" onClick={() => setMenuOpen(false)}>
              Accessories
            </Link>
          </li>

        </ul>

        <div className="nav-icons">

          <FaSearch />

          <FiUser />

          <Link to="/cart" className="cart-icon">
            <HiOutlineShoppingBag />

            {cartCount > 0 && (
              <span className="cart-count">
                {cartCount}
              </span>
            )}
          </Link>

        </div>

      </nav>
    </>
  );
}

export default Navbar;